import { getSizesString } from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import { DEFAULT_PACKAGE_IMAGE } from '../../utils/constants';
import BasePackageAndClassImage, {
  type BasePackageAndClassImageProps,
} from '../common/BasePackageAndClassImage';

type OfferingPackageImage = Omit<
  BasePackageAndClassImageProps,
  'defaultImageProps'
>;

export const OfferingPackageImage: FC<OfferingPackageImage> = ({
  sizes,
  ...basePackageAndClassImage
}) => {
  const defaultImageProps = {
    src: DEFAULT_PACKAGE_IMAGE,
    sizes: getSizesString(sizes),
  };

  return (
    <BasePackageAndClassImage
      sizes={sizes}
      defaultImageProps={defaultImageProps}
      {...basePackageAndClassImage}
    />
  );
};
